import React, { useEffect, useState } from "react";
import { Table, Button, Typography, Divider, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
// import {
//   ChangeTrainerSearchText,
//   ChangeStudentTableData,
//   ChangeTrainerModalState,
// } from "../../../actions/adminAction";
import "../allStudent/allstudent.css";

import CrossIcon from "../../../assets/crossIcon.svg";
import { retriveToken, getAllPastOrders } from "../../../services/AuthServices";
import { InfoCircleOutlined } from "@ant-design/icons";

const AllPastOrder = () => {
  const [isInfo, setIsInfo] = useState(false);
  const [activeObject, setActiveObject] = useState();

  const [pastOrders, setPastOrders] = useState([]);

  useEffect(() => {
    const t = retriveToken();
    if (t && t !== "undefined") {
      getAllPastOrders(t).then((response) => {
        setPastOrders(response?.data?.data);
      });
    } else {
      window.location = "/";
    }
  }, []);

  const { Title } = Typography;
  const columns = [
    {
      title: <span style={{ color: "black" }}>Name</span>,
      dataIndex: "userId",
      key: "userId",
      render: (key, obj) =>
        <span style={{ color: "black" }}>{obj?.userId?.name || "N/A"}</span> ,
    },
    {
      title: <span style={{ color: "black" }}>Order name</span>,
      dataIndex: "rewardId",
      key: "rewardId",
      render: (key, obj) =>
        <span style={{ color: "black" }}>{obj?.rewardId?.name || "N/A"}</span>,
    },
    {
      title: <span style={{ color: "black" }}>Category</span>,
      dataIndex: "rewardId",
      key: "category",
      render: (key, obj) =>
        (
          <span style={{ color: "black" }}>
            {obj?.rewardId?.categoryId?.name || "N/A"}
          </span>
        ) || "N/A",
    },
    {
      title: <span style={{ color: "black" }}>Invoice Number</span>,
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
      render: (text) => <span style={{ color: "black" }}>{text}</span> || "N/A",
    },
    {
      title: <span style={{ color: "black" }}>Date Ordered</span>,
      dataIndex: "date",
      key: "date",
      render: (text) =>
        (
          <span style={{ color: "black" }}>{`${
            new Date(text).getMonth() + 1
          }/${new Date(text).getDate()}/${new Date(text).getFullYear()}`}</span>
        ) || "N/A",
    },
    {
      title: <span style={{ color: "black" }}>Action</span>,
      key: "action",
      render: (_, obj) => (
        <>
          <Button
            type="primary"
            shape="circle"
            icon={<InfoCircleOutlined />}
            onClick={() => {
              setActiveObject(obj);
              setIsInfo(true);
            }}
          />
          <Divider type="vertical" />
        </>
      ),
    },
  ];

  return (
    <>
      <div className="admin-table-container">
        <div className="register-trainer-form-header">
          <Title level={4} style={{ color: "#fff", textAlign: "center" }}>
            Past Orders
          </Title>
        </div>
        <Table
          bordered={true}
          columns={columns}
          dataSource={pastOrders}
          size="medium"
          pagination={{ pageSize: 10 }}
          rowKey="_id"
          style={{ backgroundColor: "#fff", padding: "10px" }}
        />
      </div>
      <Modal
        open={isInfo}
        footer={null}
        closable={false}
        onCancel={() => setIsInfo(false)}
        className="rewardMModalAdmin"
        width={350}
        style={{
          top: "30%",
          borderRadius: "25px",
          backgroundColor: "#ffff",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: "6px",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <img
              style={{ cursor: "pointer" }}
              src={CrossIcon}
              alt=""
              onClick={() => setIsInfo(false)}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "6px",
              width: "100%",
            }}
          >
            <Typography
              style={{ padding: 0, marginTop: 3 }}
              className="cretaCateText"
            >
              Invoice Number: {activeObject?.invoiceNumber}
            </Typography>
            <Typography>
              Customer Name: {activeObject?.userId?.name}{" "}
            </Typography>
            <Typography>
              Name: {activeObject?.rewardId?.categoryId?.name}
            </Typography>
            <Typography>
              Date Ordered:
              {`${new Date(activeObject?.date).getMonth() + 1}/${new Date(
                activeObject?.date
              ).getDate()}/${new Date(activeObject?.date).getFullYear()}`}
            </Typography>
            <Typography>
              Date Delivered:
              {`${
                new Date(activeObject?.deliverDate).getMonth() + 1
              }/${new Date(activeObject?.deliverDate).getDate()}/${new Date(
                activeObject?.deliverDate
              ).getFullYear()}`}
            </Typography>
            <Typography>Order Cost: {activeObject?.rewardId?.cost}</Typography>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AllPastOrder;
